// extracted by mini-css-extract-plugin
module.exports = {"tcoButton":"_3p5CGi","tcoButtonDisabled":"_21jFlD"};